<template>
	<UnidadeLayout>
		<LoaderPage v-if="loadingPage" />
		<div :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-min-h-screen">
			<div :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-pt-8 tw-pb-4 tw-px-5">
				<div class="tw-flex tw-justify-between tw-items-center tw-max-w-7xl tw-mx-auto">
					<h2 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-slate-800'" class="tw-text-3xl tw-font-bold tw-mb-2">
						Sistema de Consulta Avançada
					</h2>
					<router-link 
						to="/v2/unidades"
						:class="theme === 'dark'
							? 'tw-bg-slate-800 hover:tw-bg-slate-700 tw-text-white'
							: 'tw-bg-green-500 hover:tw-bg-green-600 tw-text-white'"
						class="tw-inline-flex tw-items-center tw-gap-2 tw-px-4 tw-py-3 tw-rounded-lg tw-font-semibold tw-shadow hover:tw-shadow-lg tw-whitespace-nowrap"
						title="Consulta Avançada"
					>
						<i class="fa-solid fa-house tw-mr-2"></i>
						<span>Unidades</span>
					</router-link>
				</div>
			</div>
			<div :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-px-5">
				<div class="tw-max-w-6xl tw-mx-auto tw-space-y-6">
					<div :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'" class="tw-rounded-lg tw-shadow-lg">
						<div class="tw-bg-blue-600 tw-text-white tw-px-4 tw-py-4 tw-flex tw-items-center tw-gap-3">
							<svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
							</svg>
							<h2 class="tw-text-lg tw-font-bold">Configuração da Consulta</h2>
						</div>
						<div class="tw-p-4 tw-space-y-6">
							<div>
								<div class="tw-flex tw-flex-row tw-items-center tw-justify-between tw-gap-3 tw-mb-4">
									<h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-text-base tw-font-semibold">
										Parâmetros de Consulta
									</h3>
									<button 
										@click="addParametroConsulta()" 
										:class="theme === 'dark' ? 'tw-bg-blue-600 hover:tw-bg-blue-700 tw-text-white' : 'tw-bg-blue-600 hover:tw-bg-blue-700 tw-text-white'"
										class="tw-inline-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium"
									>
										<span class="tw-text-lg">+</span> Adicionar parâmetro
									</button>
								</div>
								<div 
									v-if="parametrosConsulta.length === 0"
									@click="addParametroConsulta()"
									:class="theme === 'dark' ? 'tw-bg-slate-800 tw-border-slate-600 tw-text-slate-400' : 'tw-bg-slate-100 tw-border-slate-300 tw-text-slate-600'"
									class="tw-text-center tw-py-8 tw-rounded-lg tw-border-2 tw-border-dashed tw-cursor-pointer hover:tw-shadow-md"
								>
									<svg class="tw-w-12 tw-h-12 tw-mx-auto tw-mb-2 tw-opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
									</svg>
									<p class="tw-font-medium">Nenhum parâmetro de consulta configurado</p>
									<p class="tw-text-sm">Clique aqui ou em "Adicionar parâmetro" para começar</p>
								</div>
								<div v-else class="tw-space-y-2">
									<div v-for="(parametro, index) in parametrosConsulta" :key="index" class="tw-w-fulltw-flex tw-flex-row tw-items-center tw-gap-3 tw-pb-2">
										<div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-p-3 tw-rounded-lg" :class="theme === 'dark' ? 'tw-bg-slate-800' : 'tw-bg-slate-100'">		
											<div v-if="index > 0" class="tw-flex tw-items-center tw-justify-center tw-w-20">
												<span :class="theme === 'dark' ? 'tw-bg-emerald-600 tw-text-white' : 'tw-bg-emerald-500 tw-text-white'" class="tw-px-3 tw-py-2 tw-rounded tw-text-xs tw-font-bold">
													E
												</span>
											</div>
											<input v-if="index == 0" type="text" value="Silos" disabled
												:class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-slate-300' : 'tw-bg-slate-200 tw-text-slate-700'"
												class="tw-p-3 tw-rounded tw-text-sm tw-font-medium tw-w-20"
											/>
											<select v-model="parametro.que_ou_quenao" 
												:class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-white' : 'tw-bg-white tw-text-slate-900'"
												class="tw-p-3 tw-rounded tw-text-sm tw-w-20 tw-w-auto"
											>
												<option value="que" selected>que</option>
												<option value="quenao">que não</option>
											</select>
											<select v-model="parametro.tipo" 
												:class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-white' : 'tw-bg-white tw-text-slate-900'"
												class="tw-p-3 tw-rounded tw-text-sm tw-flex-grow tw-flex-grow-0 min-w-0 tw-min-w-[250px]"
											>
												<option disabled value="">Selecione um parâmetro</option>
												<option value="data==">data e hora</option>
												<option value="nivel_>">nível acima de</option>
												<option value="nivel_<">nível abaixo de</option>
												<option value="produto_==">o produto seja</option>
												<option value="mediaatual_>">média atual acima de</option>
												<option value="mediaatual_<">média atual abaixo de</option>
												<option value="contemaeracaoligada">estejam com a aeração ligada</option>
												<option value="contemcabosoff">contenham sensores off</option>
												<option value="contemsensores_>">contenham temperaturas acima de</option>
												<option value="contemsensores_<">contenham temperaturas abaixo de</option>
											</select>
											<input
												v-if="['contemsensores_>', 'contemsensores_<', 'mediaatual_>', 'mediaatual_<', 'nivel_>', 'nivel_<'].includes(parametro.tipo)"
												v-model.number="parametro.valor"
												type="number"
												:class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-white' : 'tw-bg-white tw-text-slate-900'"
												class="tw-px-2 md:tw-p-3 tw-rounded tw-text-sm tw-w-24"
												placeholder="Valor"
												min="0"
											/>
											<input
												v-if="parametro.tipo === 'data=='"
												v-model="data"
												type="datetime-local"
												:class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-white' : 'tw-bg-white tw-text-slate-900'"
												class="tw-px-2 md:tw-p-3 tw-rounded tw-text-sm tw-w-auto"
											/>

											<select 
												v-if="parametro.tipo === 'produto_=='" v-model="parametro.valor" 
												:class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-white' : 'tw-bg-white tw-text-slate-900'"
												class="tw-px-2 md:tw-px-3 tw-py-1 tw-rounded tw-text-sm tw-w-28 md:tw-w-auto"
											>
												<option disabled value="">Produto</option>
												<option value="Vazio">Vazio</option>
												<option value="Cevada">Cevada</option>
												<option value="Feijão">Feijão</option>
												<option value="Milho">Milho</option>
												<option value="Arroz">Arroz</option>
												<option value="Sorgo">Sorgo</option>
												<option value="Soja">Soja</option>
												<option value="Trigo">Trigo</option>
												<option value="Canola">Canola</option>
												<option value="Azevém">Azevém</option>
												<option value="Linhaça">Linhaça</option>
												<option value="Painço">Painço</option>
												<option value="Alpiste">Alpiste</option>
												<option value="Milheto">Milheto</option>
												<option value="Aveia">Aveia</option>
												<option value="Girassol">Girassol</option>
												<option value="Outro">Outro</option>
											</select>
											<button 
												type="button" 
												@click="removerParametro(index)"
												:class="theme === 'dark' ? 'hover:tw-bg-red-900/50 tw-text-red-400' : 'hover:tw-bg-red-100 tw-text-red-600'"
												class="tw-p-1 tw-rounded tw-ml-auto"
											>
												<svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
													<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
												</svg>
											</button>
										</div>
									</div>
								</div>
							</div>
							<div :class="theme === 'dark' ? 'tw-border-slate-700' : 'tw-border-slate-200'" class="tw-border-t"/>
							<div>
								<h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-text-base tw-font-semibold tw-mb-4">
									Unidades para Consulta
								</h3>
								<div class="tw-flex tw-flex-col tw-gap-3 tw-mb-4">
									<div class="tw-flex tw-flex-row tw-gap-2">
										<select 
											v-model="selectedUnidadeId" 
											@change="addSelectedUnidade"
											:class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-white tw-text-slate-900'"
											class="tw-flex-grow tw-px-3 tw-py-2 tw-rounded-lg tw-text-sm"
										>
											<option disabled selected value="">Selecione as unidades</option>
											<option v-for="unidade in unidadesDisponiveis" :key="unidade.id" :value="unidade.id">
												{{ unidade.nome }}
											</option>
										</select>
										<button 
											type="button" 
											@click="selecionarTodasUnidades"
											:class="theme === 'dark' ? 'tw-bg-blue-700 hover:tw-bg-blue-600 tw-text-white' : 'tw-bg-blue-600 hover:tw-bg-blue-700 tw-text-white'"
											class="tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium tw-whitespace-nowrap tw-text-sm"
										>
											Selecionar Todas
										</button>
										<button 
											type="button" 
											@click="limparUnidades"
											:class="theme === 'dark' ? 'tw-bg-slate-700 hover:tw-bg-slate-600 tw-text-slate-100' : 'tw-bg-slate-300 hover:tw-bg-slate-400 tw-text-slate-800'"
											class="tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium tw-whitespace-nowrap tw-text-sm"
										>
											Limpar
										</button>
									</div>
									<div :class="theme === 'dark' ? '' : 'tw-bg-slate-100'" class="tw-p-3 tw-rounded-lg tw-min-h-[60px] tw-flex tw-flex-wrap tw-gap-2 tw-items-start tw-content-start">
										<div v-if="unidadesSelecionadas.length === 0" :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-600'" class="tw-w-full tw-text-center tw-text-sm tw-py-2">
											Nenhuma unidade selecionada
										</div>
										<div 
											v-for="unidade in unidadesSelecionadas" 
											:key="unidade.id"
											:class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-slate-100' : 'tw-bg-white tw-text-slate-800'"
											class="tw-inline-flex tw-items-center tw-gap-2 tw-p-3 tw-rounded tw-text-sm tw-whitespace-nowrap"
										>
											<span>{{ unidade.nome }}</span>
											<button 
												type="button" 
												@click="removerUnidade(unidade.id)"
												class="tw-ml-1 hover:tw-text-red-500"
											>
												<svg class="tw-w-4 tw-h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
													<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
												</svg>
											</button>
										</div>
									</div>
								</div>
								<div :class="theme === 'dark' ? 'tw-border-slate-700' : 'tw-border-slate-200'" class="tw-border-t tw-my-4"/>
								<h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-text-base tw-font-semibold tw-mb-3">
									Colunas a Serem Exibidas
								</h3>
								<div class="tw-grid tw-grid-cols-2 tw-gap-3">
									<label class="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer">
										<input type="checkbox" checked disabled class="tw-rounded tw-w-4 tw-h-4">
										<span :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-sm">Silo</span>
									</label>
									<label class="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer">
										<input type="checkbox" v-model="colunasTable.nivel" class="tw-rounded tw-w-4 tw-h-4">
										<span :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-sm">Nível</span>
									</label>
									<label class="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer">
										<input type="checkbox" v-model="colunasTable.produto" class="tw-rounded tw-w-4 tw-h-4">
										<span :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-sm">Produto</span>
									</label>
									<label class="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer">
										<input type="checkbox" v-model="colunasTable.data_ultimo_registro" class="tw-rounded tw-w-4 tw-h-4">
										<span :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-sm">Data do Registro</span>
									</label>
									<label class="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer">
										<input type="checkbox" v-model="colunasTable.media_atual" class="tw-rounded tw-w-4 tw-h-4">
										<span :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-sm">Média do Grão</span>
									</label>
									<label class="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer">
										<input type="checkbox" v-model="colunasTable.status_motores" class="tw-rounded tw-w-4 tw-h-4">
										<span :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-sm">Status Aeração</span>
									</label>
								</div>
							</div>
							<div class="tw-pt-4">
								<button 
									type="button" 
									@click="executarConsulta()"
									class="tw-w-full tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-bg-green-600 hover:tw-bg-green-700 tw-text-white tw-px-6 tw-py-3 tw-rounded-lg tw-font-semibold"
								>
									<svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
									</svg>
									Executar Consulta
								</button>
							</div>
						</div>
					</div>
					<div v-if="consultaFeita" :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'" class="tw-rounded-lg tw-shadow-lg">
						<div class="tw-bg-emerald-600 tw-text-white tw-px-4 tw-py-4 tw-flex tw-items-center tw-justify-between tw-gap-3">
							<div class="tw-flex tw-items-center tw-gap-3">
								<svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7m0 0c0 2.21-3.582 4-8 4s-8-1.79-8-4m0 0C3.456 2.639 5.106 2 8 2s4.544.639 8 2" />
								</svg>
								<h2 class="tw-text-lg tw-font-bold">Resultado da Consulta</h2>
							</div>
							<span class="tw-bg-white tw-text-emerald-600 tw-px-3 tw-py-1 tw-rounded-full tw-text-sm tw-font-semibold">
								{{ totalSilos }} resultado(s)
							</span>
						</div>
						<div class="tw-p-4">
							<div v-if="resultUnidadesWithSilos.length < 1" class="tw-text-center tw-py-12">
								<svg class="tw-w-16 tw-h-16 tw-mx-auto tw-mb-4 tw-opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7m0 0c0 2.21-3.582 4-8 4s-8-1.79-8-4m0 0C3.456 2.639 5.106 2 8 2s4.544.639 8 2" />
								</svg>
								<h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-text-lg tw-font-semibold tw-mb-2">
									Nenhum resultado encontrado
								</h3>
								<p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-600'" class="tw-text-sm">
									Revise os parâmetros de consulta e execute a busca novamente
								</p>
							</div>
							<div v-else class="tw-space-y-6">
								<div 
									v-for="unidade in resultUnidadesWithSilos" 
									:key="unidade.id"
									:class="theme === 'dark' ? 'tw-bg-slate-800' : 'tw-bg-slate-50'"
									class="tw-rounded-lg"
								>
									<div :class="theme === 'dark' ? 'tw-bg-slate-700' : 'tw-bg-slate-200'" class="tw-px-6 tw-py-3 tw-flex tw-items-center tw-gap-3">
										<svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
											<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
										</svg>
										<h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-font-semibold tw-text-base">
											{{ unidade.nome }}
										</h3>
									</div>
									<div class="tw-relative">
										<div>
											<table class="tw-w-full tw-text-sm">
												<thead :class="theme === 'dark' ? 'tw-bg-slate-700' : 'tw-bg-slate-300'">
													<tr>
														<th :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-px-4 tw-py-3 tw-text-center tw-font-semibold">Local</th>
														<th v-if="colunasTable.produto" :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-px-4 tw-py-3 tw-text-center tw-font-semibold">Produto</th>
														<th v-if="colunasTable.data_ultimo_registro" :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-px-4 tw-py-3 tw-text-center tw-font-semibold">Data do Registro</th>
														<th v-if="colunasTable.nivel" :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-px-4 tw-py-3 tw-text-center tw-font-semibold">Nível</th>
														<th v-if="colunasTable.media_atual" :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-px-4 tw-py-3 tw-text-center tw-font-semibold">Média (°C)</th>
														<th v-if="colunasTable.status_motores" :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-px-4 tw-py-3 tw-text-center tw-font-semibold">Motores</th>
														<th v-if="parametrosConsulta.some(p => p.tipo === 'contemcabosoff')" :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-px-4 tw-py-3 tw-text-center tw-font-semibold">Sensores OFF</th>
														<th v-if="parametrosConsulta.some(p => (p.tipo === 'contemsensores_<' || p.tipo === 'contemsensores_>'))" :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-px-4 tw-py-3 tw-text-center tw-font-semibold">Sensores</th>
														<th :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-900'" class="tw-px-4 tw-py-3 tw-text-center tw-font-semibold">Ações</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="silo in unidade.silos" :key="silo.id" :class="theme === 'dark' ? 'hover:tw-bg-slate-700/50' : 'hover:tw-bg-slate-100/50'">
														<td :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-text-center tw-px-4 tw-py-3 tw-font-medium">{{ silo.nome }}</td>
														<td v-if="colunasTable.produto" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-600'" class="tw-px-4 tw-py-3 tw-text-center tw-text-sm">{{ silo.ultima_leitura.produto }}</td>
														<td v-if="colunasTable.data_ultimo_registro" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-600'" class="tw-px-4 tw-py-3 tw-text-center tw-text-sm">{{ silo.ultima_leitura.data }}</td>
														<td v-if="colunasTable.nivel" class="tw-px-4 tw-py-3 tw-text-center">
															<div class="tw-space-y-1">
																<div class="tw-flex tw-items-center tw-justify-center tw-mb-1">
																	<span :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-text-center tw-font-semibold tw-text-sm">
																		{{ (silo.nivel).toFixed(1) }}%
																	</span>
																</div>
																<div :class="theme === 'dark' ? 'tw-bg-slate-700' : 'tw-bg-slate-300'" class="tw-h-2 tw-rounded-full tw-overflow-hidden">
																	<div class="tw-h-full tw-bg-emerald-500" :style="{ width: silo.nivel + '%' }"></div>
																</div>
																<span :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-600'" class="tw-text-xs">
																	{{ parseInt((silo.nivel / 100) * parseInt(silo.capacidade)) }} / {{ parseInt(silo.capacidade) }}
																</span>
															</div>
														</td>
														<td v-if="colunasTable.media_atual" class="tw-px-4 tw-py-3 tw-text-center tw-font-bold tw-text-sm" :style="{ color: getCorPorTemperatura(silo.media_atual) }">
															{{ silo.media_atual }}°C
														</td>
														<td v-if="colunasTable.status_motores" class="tw-px-4 tw-py-3 tw-text-center">
															<div v-if="!silo.aeracao" :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-600'" class="tw-text-sm">
																Sem aeração
															</div>
															<div v-else class="tw-flex tw-flex-col tw-gap-1 tw-justify-center">
																<div 
																	v-for="motor in silo.aeracao.motores" 
																	:key="motor.id"
																	:class="motor.status == 1 
																		? (theme === 'dark' ? 'tw-bg-emerald-500/20 tw-text-emerald-300' : 'tw-bg-emerald-100 tw-text-emerald-700')
																		: (theme === 'dark' ? 'tw-bg-red-500/20 tw-text-red-300' : 'tw-bg-red-100 tw-text-red-700')"
																	class="tw-px-2 tw-py-1 tw-rounded tw-text-xs tw-font-medium tw-whitespace-nowrap"
																>
																	{{ motor.descricao }}: {{ motor.status == 1 ? 'Ligado' : 'Desligado' }}
																</div>
															</div>
														</td>
														<td v-if="parametrosConsulta.some(p => p.tipo === 'contemcabosoff')" class="tw-px-4 tw-py-3 tw-text-center tw-relative">
															<div v-if="silo.sensores_off && Object.keys(silo.sensores_off).length > 0">
																<button
																	@mouseover="showOffPopoverIndex = silo.id"
																	@mouseleave="showOffPopoverIndex = null"
																	class="tw-px-2 tw-py-1 tw-rounded tw-bg-red-500/20 tw-text-red-600 dark:tw-text-red-400 tw-text-xs tw-font-semibold hover:tw-shadow-md"
																>
																	{{ Object.values(silo.sensores_off).reduce((acc, sensores) => acc + sensores.length, 0) }} problema(s)
																</button>
																<div
																	v-if="showOffPopoverIndex === silo.id"
																	:class="theme === 'dark' ? 'tw-bg-slate-900 tw-border-slate-700' : 'tw-bg-white tw-border-slate-300'"
																	class="tw-absolute tw-z-[999] tw-top-full tw-left-1/2 tw--translate-x-1/2 tw-mt-2 tw-p-2 tw-rounded tw-border tw-text-xs tw-min-w-max tw-shadow-lg"
																>
																	<div v-for="(sensores, cabo) in silo.sensores_off" :key="cabo" :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-mb-1">
																		<strong>Cabo {{ cabo }}:</strong> {{ sensores.join(', ') }}
																	</div>
																</div>
															</div>
														</td>
														<td v-if="parametrosConsulta.some(p => (p.tipo === 'contemsensores_>' || p.tipo === 'contemsensores_<'))" class="tw-px-4 tw-py-3 tw-text-center tw-relative">
															<div v-if="silo.sensores_match && Object.keys(silo.sensores_match).length > 0">
																<button
																	@mouseover="showMatchPopoverIndex = silo.id"
																	@mouseleave="showMatchPopoverIndex = null"
																	class="tw-px-2 tw-py-1 tw-rounded tw-bg-amber-500/20 tw-text-amber-600 dark:tw-text-amber-400 tw-text-xs tw-font-semibold hover:tw-shadow-md"
																>
																	{{ Object.values(silo.sensores_match).reduce((acc, sensores) => acc + sensores.length, 0) }} sensor(es)
																</button>
																<div
																	v-if="showMatchPopoverIndex === silo.id"
																	:class="theme === 'dark' ? 'tw-bg-slate-900' : 'tw-bg-white'"
																	class="tw-absolute tw-z-50 tw-top-full tw-left-1/2 tw--translate-x-1/2 tw-mt-2 tw-p-2 tw-rounded tw-text-xs tw-min-w-max tw-shadow-lg tw-max-w-xs"
																>
																	<div v-for="(sensores, cabo) in silo.sensores_match" :key="cabo" :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-mb-1">
																		<strong>Cabo {{ cabo }}:</strong>
																		<div class="tw-flex tw-flex-wrap tw-gap-1 tw-mt-1">
																			<span 
																				v-for="sensor in sensores" 
																				:key="sensor"
																				class="tw-text-white tw-px-1.5 tw-py-0.5 tw-rounded tw-text-xs"
																				:style="{ backgroundColor: getCorPorTemperatura(sensor.temperatura) }"
																			>
																				{{ sensor.sensor }} | {{ sensor.temperatura }}°C
																			</span>
																		</div>
																	</div>
																</div>
															</div>
														</td>
														<td class="tw-px-4 tw-py-3 tw-text-center">
															<button
																@click="openInNewTab(unidade.id, silo.id)"
																class="tw-text-blue-600 hover:tw-text-blue-700 dark:tw-text-blue-400 dark:hover:tw-text-blue-300 tw-font-medium tw-text-sm hover:tw-underline"
															>
																Acessar
															</button>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</UnidadeLayout>
</template>
<script>
import temperaturaCores from "@/assets/colors.json";
import UnidadeLayout from "@/components/layouts/v2/UnidadeLayout.vue";
import LoaderPage from "@/components/ui/v2/LoaderPage.vue";
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useToast } from 'vue-toastification';

export default {
	name: "ConsultaAvancadaPage",
	components: {
		UnidadeLayout,
		LoaderPage,
	},
	methods: {
		openInNewTab(unidadeId, siloId) {
			const route = this.$router.resolve(`/v2/unidades/${unidadeId}/silos/${siloId}`);
			window.open(route.href, '_blank');
		}
	},
	data() {
		return {
			showOffPopoverIndex: null,
			showMatchPopoverIndex: null,
		};
	},
	setup() {
		const store = useStore();
		const toast = useToast();
		const vue_app_name = process.env.VUE_APP_NAME;

		const unidades = ref([]);
		const unidadesSelecionadas = ref([]);
		const selectedUnidadeId = ref("");
		const parametrosConsulta = ref([]);
		const loadingPage = ref(false);
		const resultUnidadesWithSilos = ref([]);
		const colunasTable = ref({});
		const consultaFeita = ref(false);

		const now = new Date();
		now.setHours(now.getHours() - 3);
		const dataInicial = ref(now.toISOString().slice(0, 16));
		const data = ref(dataInicial.value);

		const theme = computed(() => store.state.ui.theme);

		const getCorPorTemperatura = (temp) => {
			temp = Number(temp);

            const faixas = Object.keys(temperaturaCores)
                .map(Number)
                .sort((a, b) => a - b);            

            for (let i = 0; i <= faixas.length - 1; i++) {
                if (temp <= faixas[i]) {
                    return temperaturaCores[faixas[i]];
                }
            }

            return "#c31313";
		};

		const addParametroConsulta = () => {
			consultaFeita.value = false;
			parametrosConsulta.value.push({
				que_ou_quenao: "que",
				tipo: "",
				valor: null
			});
		};

		const removerParametro = (index) => {
			const param = parametrosConsulta.value[index];
			parametrosConsulta.value.splice(index, 1);
			if (param && param.tipo === "data==") {
				data.value = dataInicial.value;
			}
		};

		const addSelectedUnidade = () => {
			const unidade = unidadesDisponiveis.value.find(u => u.id === selectedUnidadeId.value);
			if (unidade && !unidadesSelecionadas.value.some(u => u.id === unidade.id)) {
				unidadesSelecionadas.value.push(unidade);
			}
			selectedUnidadeId.value = "";
		};

		const removerUnidade = (id) => {
			unidadesSelecionadas.value = unidadesSelecionadas.value.filter(u => u.id !== id);
		};

		const selecionarTodasUnidades = () => {
			unidadesSelecionadas.value = [];
			unidadesSelecionadas.value = [...unidadesDisponiveis.value];
		};

		const limparUnidades = () => {
			unidadesSelecionadas.value = [];
		};

		const totalSilos = computed(() => {
			return resultUnidadesWithSilos.value.reduce((total, unidade) => total + (unidade.silos ? unidade.silos.length : 0), 0);
		});

		const unidadesDisponiveis = computed(() => {
			return unidades.value.filter(
				u => !unidadesSelecionadas.value.some(sel => sel.id === u.id)
			);
		});

		const executarConsulta = async () => {
			consultaFeita.value = false;
			loadingPage.value = true;
			if (unidadesSelecionadas.value.length === 0) {
				toast.error("Selecione pelo menos uma unidade.");
				loadingPage.value = false;
				return;
			}
			const ids = unidadesSelecionadas.value.map(u => u.id);
			const regras = parametrosConsulta.value
				.filter(param => param.tipo !== "data==")
				.map(param => {
				let str = param.que_ou_quenao;
				str += "_" + param.tipo + "_";
				str+= param.valor !== null ? param.valor : "0";
				return str;
			});
			let resultUnidades = await store.dispatch("unidades/fetchUnidadesConsultaAvancada", {ids, regras, data: data.value});
			resultUnidadesWithSilos.value = resultUnidades.filter(unidade => unidade.silos && unidade.silos.length > 0);
			loadingPage.value = false;
			consultaFeita.value = true;
			toast.success("Consulta executada com sucesso!");
		};

		onMounted(async () => {
			try {
				unidades.value = store.state.unidades.unidades.filter(u => u.status === 'ativo');
				if (unidades.value.length === 0) {
					await store.dispatch("unidades/fetchUnidades");
					unidades.value = store.state.unidades.unidades.filter(u => u.status === 'ativo');
				}
			} catch (error) {
				console.error("Erro ao buscar unidades:", error);
				toast.error("Erro ao buscar unidades");
			}
		});

		return {
			unidades,
			unidadesSelecionadas,
			selectedUnidadeId,
			unidadesDisponiveis,
			vue_app_name,
			parametrosConsulta,
			executarConsulta,
			loadingPage,
			resultUnidadesWithSilos,
			totalSilos,
			colunasTable,
			addParametroConsulta,
			removerParametro,
			addSelectedUnidade,
			removerUnidade,
			selecionarTodasUnidades,
			limparUnidades,
			consultaFeita,
			getCorPorTemperatura,
			data,
			theme
		};
	},
};
</script>